var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -10 143.87 180.95",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.27 180.95a34.67 34.67 0 0169.3 0h37.26a71.93 71.93 0 00-143.86-.4v.4z",
    fill: "#297982"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.94,
    cy: 46.82,
    r: 34.82,
    fill: "none",
    stroke: "#297982",
    strokeMiterlimit: 10,
    strokeWidth: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 180.55h143.88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default ForwardRef;